export default __webpack_public_path__ + "static/media/Dr-Steven-Neubauer.0126236c.jpg";